import { typography } from '@shared/tokens/typography.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { palette } from '@shared/tokens/palette.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  button: {
    display: 'flex',
    justifySelf: 'center',
    background: colors.accentBackground,
    border: 'none',
    outline: 'none',
    borderRadius: anatomy.borderRadiusS,
    color: palette['greyWhite'],
    padding: `${anatomy['size-12']} ${anatomy['size-24']}`,
    fontSize: typography['fontSizeBody-3'],
    lineHeight: typography['lineHeightBody-3'],
    textAlign: 'center',
    width: 'max-content',
    alignSelf: 'center',
  },
  buttonText: {
    border: 'none',
    outline: 'none',
    wordBreak: 'break-word',
    minWidth: '2px',
  },
  buttonPointer: {
    cursor: 'pointer',
  },
});
